/* eslint-disable @typescript-eslint/member-ordering */
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { HomeService } from '../home.service';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { InfiniteCarousel } from 'app/shared/utils/infinite-carousel';
import { EVENT_RATE_CACHE_STORAGE_KEY } from 'app/shared/utils/event-rate-cache';
import { setting } from '../../../../setting';

interface PackageSlide {
  title: string;
  subtitle: string;
  location: string;
  regionName: string;
  regionRaw: string;
  categoriaRaw: string;
  descriptionPlain: string;
  descriptionShort: string;
  image: string;
  archivo: any;
  locationCity: string;
}

@Component({
  selector: 'usb-packages-small',
  templateUrl: './packages-small.component.html',
  styleUrls: ['./packages-small.component.scss']
})
export class PackagesSmallComponent implements OnInit {
  @Input() getClientsSettingAppBooking: any;

  public clientSettingGlobal: any;
  public packagesArr: PackageSlide[] = [];
  private apiStorage = setting.apiBookingUrl;

  private agencyInfo: any;
  // Respuesta cruda del último ratesInfo(type:1), para no volver a pedirla si el usuario navega
  // a "Circuitos" (event-rate-mannager) desde acá (ver goToCircuits()).
  private lastRatesResponse: any = null;

  carousel = new InfiniteCarousel<PackageSlide>(768, 1, 3);

  constructor(
    private homeService: HomeService,
    private notificationService: NotificationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.clientSettingGlobal = this.getClientsSettingAppBooking?.clients_setting_global;
    this.agencyInfo = JSON.parse(localStorage.getItem('selectedAgency') || 'null');

    this.carousel.setViewportWidth(window.innerWidth);
    this.getPackages();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.carousel.setViewportWidth(window.innerWidth);
  }

  downloadPdf(archivo: any): void {
    this.notificationService.info('Su descarga comienza en un momento');
    const paramsUrl = this.paramsUrlInit();
    this.homeService.downloadDocument(archivo, paramsUrl);
  }

  // Misma ruta que usa "Circuitos" en el menú hamburguesa (header.component.ts, mannagementRedirect typeOption 2).
  // region/categoria le indican a usb-event-rate-mannager qué acordeón abrir y hasta qué card scrollear.
  goToCircuits(regionRaw: string, categoriaRaw: string): void {
    // Ya tenemos esta misma data (type:1, mismos params porque salen de la misma agencyInfo) —
    // se la dejamos cacheada a event-rate-mannager para que no la vuelva a pedir.
    if (this.lastRatesResponse) {
      sessionStorage.setItem(EVENT_RATE_CACHE_STORAGE_KEY, JSON.stringify({
        type: 1,
        tipoNombre: this.lastRatesResponse.tipo_nombre,
        regiones: this.lastRatesResponse.regiones
      }));
    }
    this.router.navigate(['shortCutsMannager', 'circuit'], {
      queryParams: { region: regionRaw, categoria: categoriaRaw }
    });
  }

  // Mismos parámetros que usa usb-event-rate-mannager para consultar "Circuitos" (type: 1).
  private paramsUrlInit(): any {
    return {
      channel: this.agencyInfo?.channel_id === 2 ? 'minorista' : 'mayorista',
      location_agency_id: this.agencyInfo?.location_agency_id === 1 ? 'exterior' : 'exterior',
      language: this.agencyInfo?.language === 39 ? 2 : 1,
    };
  }

  private getPackages(): void {
    const paramsUrl = this.paramsUrlInit();
    paramsUrl.type = 1;

    this.homeService.ratesInfo(paramsUrl).subscribe({
      next: (res: any) => {
        if (res && Array.isArray(res.regiones)) {
          this.lastRatesResponse = res;
          this.packagesArr = this.flattenPackages(res.regiones);
          this.carousel.setItems(this.packagesArr);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  private flattenPackages(regiones: any[]): PackageSlide[] {
    const packages: PackageSlide[] = [];

    regiones.forEach((region: any) => {
      (region.categorias || []).forEach((categoria: any) => {
        (categoria.archivos || []).forEach((archivo: any, index: number) => {
          if(archivo?.descripcion !== '' && index === 0) {
            const { title, dates } = this.splitDisplay(archivo.display);
            const descriptionPlain = this.stripHtml(archivo.descripcion);
            packages.push({
                            title,
                            subtitle: this.normalizeDuration(dates),
                            locationCity: `${categoria.categoria_nombre}`,
                            location: `${categoria.categoria_nombre} - ${region.region}`,
                            regionName: categoria.categoria_nombre === 'Combinados' ? `${categoria?.categoria_nombre} EN ${region?.region}` : categoria.categoria_nombre,
                            regionRaw: region.region,
                            categoriaRaw: categoria.categoria_nombre,
                            descriptionPlain,
                            descriptionShort: this.truncateText(descriptionPlain, 90),
                            image: this.getImage(categoria, region),
                            archivo,
                          });
          }


          packages.sort((a: any) => {

            if(
                //  a.locationCity === 'BARILOCHE' ||
                //  a.locationCity === 'EL CALAFATE' ||
                 a.locationCity === 'MENDOZA' ||
                 a.locationCity === 'BUENOS AIRES' ||
                 a.locationCity === 'USHUAIA'
              ) {
                  return -1;
                 };

                 return 1;

          });
        });
      });
    });

    return packages;
  }

   getImage(categoria: any, region: any): string {

    if(!categoria.imagen || categoria.imagen === '') {
      return '';
    }

    if(!region) {
      return '';
    }

    switch(categoria.categoria_nombre) {
      case 'BARILOCHE':
          return '../../../assets/img/app/packages-images/BARILOCHE.jpg';
      case 'BUENOS AIRES':
          return '../../../assets/img/app/packages-images/BUENOS_AIRES.jpg';
      case 'EL CALAFATE':
          return '../../../assets/img/app/packages-images/CALAFATE.jpg';
      case 'MENDOZA':
          return '../../../assets/img/app/packages-images/CUYO.jpg';
      case 'USHUAIA':
          return '../../../assets/img/app/packages-images/USHUAIA.jpg';
      case 'SANTIAGO DE CHILE':
          return '../../../assets/img/app/packages-images/SANTIAGO_DE_CHILE.jpg';
      case 'SAN PEDRO DE ATACAMA':
          return '../../../assets/img/app/packages-images/ATACAMA.jpg';
      case 'ISLA DE PASCUA':
          return '../../../assets/img/app/packages-images/ISLA_PASCUA.jpg';

      default:
        return `https://legacy.moebius.tur.ar/verIcono/${categoria.imagen}`;
    }
   }

  // El display siempre viene como "Nombre - Días" (ej: "Bariloche Clásico - 4D/3N 2025-2026").
  private splitDisplay(display: string): { title: string; dates: string } {
    if (!display) {
      return { title: '', dates: '' };
    }

    const separatorIndex = display.indexOf(' - ');
    if (separatorIndex === -1) {
      return { title: display.trim(), dates: '' };
    }

    return {
      title: display.slice(0, separatorIndex).trim(),
      dates: display.slice(separatorIndex + 3).trim(),
    };
  }

  // Normaliza formatos como "6D5N - 2025", "7 días 6 noches 2025", "4 días 3 noches",
  // "4D/3N 2025-2026" o "4D/3N" a "N días N noches - año/rango". Sin días/noches reconocibles, devuelve ''.
  private normalizeDuration(dates: string): string {
    if (!dates) {
      return '';
    }

    const durationMatch = dates.match(/(\d+)\s*\/?\s*(?:D|d[ií]as?)\.?\s*\/?\s*(\d+)\s*\/?\s*(?:N|noches?)\.?/i);
    if (!durationMatch) {
      return '';
    }

    const [, days, nights] = durationMatch;
    const parts = [`${days} días ${nights} noches`];

    const yearMatch = dates.match(/(\d{4}(?:\s*-\s*\d{4})?)\s*$/);
    if (yearMatch) {
      parts.push(yearMatch[1].replace(/\s*-\s*/, '-'));
    }

    return parts.join(' - ');
  }

  private stripHtml(html: string): string {
    if (!html) {
      return '';
    }
    const div = document.createElement('div');
    div.innerHTML = html;
    return (div.textContent || '').trim();
  }

  private truncateText(text: string, maxLength: number): string {
    if (!text) {
      return '';
    }

    if (text.length <= maxLength) {
      return `${text}...`;
    }

    const cut = text.slice(0, maxLength);
    const lastSpace = cut.lastIndexOf(' ');
    const trimmed = (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trim();
    return `${trimmed}...`;
  }

}
